import { compose } from 'redux';

export const composeEnhancers =    
    compose;
